import axios from 'axios';

const TMDB_API_KEYS = [
  'c8dea14dc917687ac631a52620e4f7ad',
  '3cb41ecea3bf606c56552db3d17adefd'
];

let currentKeyIndex = 0;

const getApiKey = () => {
  return TMDB_API_KEYS[currentKeyIndex];
};

const rotateApiKey = () => {
  currentKeyIndex = (currentKeyIndex + 1) % TMDB_API_KEYS.length;
  return getApiKey();
};

const tmdbApi = axios.create({
  baseURL: 'https://api.themoviedb.org/3',
  params: {
    api_key: getApiKey(),
  },
});

// Retry with key rotation on rate limit
tmdbApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 429) {
      const newKey = rotateApiKey();
      error.config.params.api_key = newKey;
      return axios.request(error.config);
    }
    return Promise.reject(error);
  }
);

export const getTrending = async () => {
  const response = await tmdbApi.get('/trending/all/week');
  return response.data.results;
};

export const getNetflixOriginals = async () => {
  const response = await tmdbApi.get('/discover/tv', {
    params: {
      with_networks: 213,
    },
  });
  return response.data.results;
};

export const getTopRated = async () => {
  const response = await tmdbApi.get('/movie/top_rated');
  return response.data.results;
};

export const getActionMovies = async () => {
  const response = await tmdbApi.get('/discover/movie', {
    params: {
      with_genres: 28,
    },
  });
  return response.data.results;
};

export const getComedyMovies = async () => {
  const response = await tmdbApi.get('/discover/movie', {
    params: {
      with_genres: 35,
    },
  });
  return response.data.results;
};

export const getHorrorMovies = async () => {
  const response = await tmdbApi.get('/discover/movie', {
    params: {
      with_genres: 27,
    },
  });
  return response.data.results;
};

export const getRomanceMovies = async () => {
  const response = await tmdbApi.get('/discover/movie', {
    params: {
      with_genres: 10749,
    },
  });
  return response.data.results;
};

export const getDocumentaries = async () => {
  const response = await tmdbApi.get('/discover/movie', {
    params: {
      with_genres: 99,
    },
  });
  return response.data.results;
};

export const getMovieVideos = async (movieId) => {
  const response = await tmdbApi.get(`/movie/${movieId}/videos`);
  return response.data.results;
};

export const getTVVideos = async (tvId) => {
  const response = await tmdbApi.get(`/tv/${tvId}/videos`);
  return response.data.results;
};

export const searchContent = async (query) => {
  const response = await tmdbApi.get('/search/multi', {
    params: {
      query,
    },
  });
  return response.data.results;
};

export const IMAGE_BASE_URL = 'https://image.tmdb.org/t/p/original';
export const POSTER_BASE_URL = 'https://image.tmdb.org/t/p/w500';
